<div class="customer-summary">
  <!-- Identity block — the bar above the customer detail tabs. -->
  <div class="identity" *ngIf="showIdentity">
    <div class="identity-name">
      <mat-icon>storefront</mat-icon>
      <div>
        <div class="name">{{ customerName }}</div>
        <div class="account">
          <span *ngIf="customerData?.companyAccountNumber">Account #{{ customerData.companyAccountNumber }}</span>
          <!-- Freely's own id. It used to sit beside the sheet's title; with no title it lives here. -->
          <span class="customer-id" *ngIf="customerId">{{ customerId }}</span>
        </div>
      </div>
    </div>
    <div class="identity-address" *ngIf="hasAddress">
      <mat-icon>place</mat-icon>
      <div>
        <div *ngIf="addressLine">{{ addressLine }}</div>
        <div *ngIf="cityStateZip">{{ cityStateZip }}</div>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div class="loading-state" *ngIf="showStats && isLoading">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <!-- Stat cards — the Dashboard tab. -->
  <div class="stat-grid" *ngIf="showStats && !isLoading">
    <mat-card class="stat-card">
      <div class="stat-label">Last Invoice</div>
      <div class="stat-value" *ngIf="summary?.lastInvoice; else dash">
        {{ summary?.lastInvoice?.invoiceRef }}
      </div>
      <div class="stat-sub" *ngIf="summary?.lastInvoice">
        {{ summary?.lastInvoice?.invoiceDate | date : 'MMM dd, yyyy' }}
      </div>
    </mat-card>

    <mat-card class="stat-card">
      <div class="stat-label">Outstanding</div>
      <div class="stat-value">{{ summary?.outstandingAmount ?? 0 | currency }}</div>
      <div class="stat-sub">
        {{ summary?.numberOutstanding ?? 0 }} {{ (summary?.numberOutstanding ?? 0) === 1 ? 'invoice' : 'invoices' }}
      </div>
    </mat-card>

    <mat-card class="stat-card">
      <div class="stat-label">Last Payment</div>
      <div class="stat-value" *ngIf="summary?.lastPayment; else dash">
        {{ summary?.lastPayment?.amount | currency }}
      </div>
      <div class="stat-sub" *ngIf="summary?.lastPayment">
        {{ summary?.lastPayment?.date | date : 'MMM dd, yyyy' }} ·
        {{ summary?.lastPayment?.status }}
      </div>
    </mat-card>

    <mat-card class="stat-card">
      <div class="stat-label">Credits On File</div>
      <div class="stat-value">{{ summary?.creditsOnFile?.amount ?? 0 | currency }}</div>
      <div class="stat-sub">{{ summary?.creditsOnFile?.count ?? 0 }} credit(s)</div>
    </mat-card>
  </div>

  <ng-template #dash><div class="stat-value">—</div></ng-template>
</div>
